// Tétel (kosár / rendelés) fő képe: a tervezőben készült terv látványképe az első —
// a vásárló azt rendelte —, utána a változat, majd a termék képe.

export interface ImageSourceItem {
  custom_design?: { preview_image: string | null } | null;
  product_variant?: { image?: string | null; image_url?: string | null } | null;
  product?: {
    main_image?: string | null;
    images?: Array<{ image?: string | null; image_url?: string | null }> | null;
  } | null;
}

/** A tétel képének URL-je, vagy null (a hívó dönt a helyettesítőről). */
export function itemImageUrl(item: ImageSourceItem): string | null {
  const first = item.product?.images?.[0];
  return (
    item.custom_design?.preview_image ||
    item.product_variant?.image_url ||
    item.product_variant?.image ||
    item.product?.main_image ||
    first?.image_url ||
    first?.image ||
    null
  );
}
